import React from "react";
//import PropTypes from 'prop-types';

import Resources from "playground/cms/views/Resources";
import { FormLayout } from "playground/cms/Form";
import ResponseForm from "./ResponseForm";
import { useApiActions } from "state/hooks";
import { ListLayout } from "playground/cms/List";
import IconButton from "components/IconButton";
import { clearForms } from "cms/state/actions/forms";
import FormResponseListItem from "./FormResponseListItem";

import "./style.css";

export function Responses(props) {
    const { type } = props;
    const { onClear } = useApiActions({ onClear: clearForms });
    return (
        <Resources {...props} ListItem={FormResponseListItem}>
            <ListLayout>
                <ListLayout.Header>
                    <ListLayout.Header.Icons>
                        <IconButton icon={"mui-delete"} onClick={onClear} />
                    </ListLayout.Header.Icons>
                </ListLayout.Header>
            </ListLayout>
            <FormLayout>
                <FormLayout.Content replace={true}>
                    <FormLayout.Tab id={"form-responses"} label={"Odpowiedź"}>
                        <ResponseForm {...props} />
                    </FormLayout.Tab>
                </FormLayout.Content>
            </FormLayout>
        </Resources>
    );
}

Responses.propTypes = {};

Responses.defaultProps = {};

export default Responses;
